import { h } from "preact";
import { useEffect } from "preact/hooks";

import { classNames, renderHtml } from "../helpers";
import i18n from "../i18n";

export default function PageTitle({ children, to, ...props }) {
  useEffect(() => {
    document.title = i18n.t("page_title", {
      title: children.replaceAll(/<[^>]*>/g, ""),
    });
  }, [children]);

  const Element = to ? "a" : "h1";

  return (
    <Element {...props} href={to} class={classNames(props.class, "page-title")}>
      {renderHtml(children)}
    </Element>
  );
}
